import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {
  AsyncPageName,
  AsyncPageEmail,
  AsyncPagePhone,
  AsyncPageVerifyPhone,
  AsyncPageAddress,
  AsyncPageAddressSearchResults,
  AsyncPagePassword,
  AsyncPageDonationHistory,
  AsyncPagePaymentMethods,
  AsyncPageNotifications,
  AsyncPageNotFound,
} from 'pages/AsyncPage';
import { paths } from './constants';

import Index from './pages/Index';
import Personal from './pages/Personal';
import DonationSummary from './pages/DonationSummary';
import AppSettings from './pages/AppSettings';
import MonthlyDonations from './pages/MonthlyDonations';

export default () => (
  <Switch>
    <Route exact path="/">
      <Index />
    </Route>
    <Route exact path={paths.Personal}>
      <Personal />
    </Route>
    <Route path={paths.Name}>
      <AsyncPageName />
    </Route>
    <Route path={paths.Email}>
      <AsyncPageEmail />
    </Route>
    <Route path={paths.Phone}>
      <AsyncPagePhone />
    </Route>
    <Route path={paths.VerifyPhone}>
      <AsyncPageVerifyPhone />
    </Route>
    <Route path={paths.Password}>
      <AsyncPagePassword />
    </Route>
    <Route path={paths.DonationHistory}>
      <AsyncPageDonationHistory />
    </Route>
    <Route path={paths.DonationSummary}>
      <DonationSummary />
    </Route>
    <Route path={paths.PaymentMethods}>
      <AsyncPagePaymentMethods />
    </Route>
    <Route path={paths.Notifications}>
      <AsyncPageNotifications />
    </Route>
    <Route path={paths.Address}>
      <AsyncPageAddress />
    </Route>
    <Route path={paths.AddressResults}>
      <AsyncPageAddressSearchResults />
    </Route>
    <Route path={paths.MonthlyDonations}>
      <MonthlyDonations />
    </Route>
    <Route path={paths.Apps}>
      <AppSettings />
    </Route>
    <Route>
      <AsyncPageNotFound />
    </Route>
  </Switch>
);
